export const AUTHORIZATION_KEY = "RgUkXp2s5v8y5B8E7H1MbQeThVmYq3t6";
export const CALLING_APP       = "cashi";
export const CALLING_SOURCE    = "ReactJS";

/* export const REACT_ENV       = "DEV";
export const SV_API_URL_PATH = "https://v3.shopview.net/sapi/v4/"; 
export const API_URL_PATH    = "http://localhost:4400/sapi/panel/";  //Demo
export const API_URL_PATHAPP = "http://localhost:4400/sapi/cashiplus/"; 
 */
/* 
export const REACT_ENV       = "DEV";
export const SV_API_URL_PATH = "https://v3.shopview.net/sapi/v4/";       // Demo
export const API_URL_PATH    = "http://209.42.196.32:4400/sapi/panel/";  //Demo
export const API_URL_PATHAPP = "http://209.42.196.32:4400/sapi/cashiplus/";
*/

//export const REACT_ENV       = "LIVE";
//export const API_URL_PATH    = "http://209.42.196.32:4444/sapi/panel/";  //Demo
//export const API_URL_PATHAPP = "http://209.42.196.32:4400/sapi/cashiplus/";


export const REACT_ENV       = "LIVE";
export const SV_API_URL_PATH = "https://console.shopview.net/sapi/v4/"; //Live
export const API_URL_PATH    = "https://api.cashi.in/sapi/panel/";  //Live
export const API_URL_PATHAPP = "https://api.cashi.in/sapi/cashiplus/";  






